import React from 'react';
import { Modal, Button } from 'grab-ui';
import PropTypes from 'prop-types';
import css from './index.less';

const ConfirmModal = ({
  visible,
  title,
  body,
  okText,
  onOk,
  cancelText,
  onCancel,
}) => (
  <Modal
    className={css.confirmModal}
    visible={visible}
    footer={null}
    closable={false}
  >
    <p className={css.header}>{title}</p>
    <p className={css.body}>{body}</p>
    <div className={css.footer}>
      <Button onClick={onCancel} size="large">
        {cancelText}
      </Button>
      <Button type="primary" onClick={onOk} size="large">
        {okText}
      </Button>
    </div>
  </Modal>
);

ConfirmModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  okText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmModal;
